    // Sample data
    export const locations = [
        { location: 'A1-A-A1', quantity: 25 },
        { location: 'P1-A-P2', quantity: 30 },
        { location: 'C1-B-A1', quantity: 55 },
    ];